import { render, staticRenderFns } from "./Basics.vue?vue&type=template&id=1d25a2c6&scoped=true&"
import script from "./Basics.vue?vue&type=script&lang=javascript&"
export * from "./Basics.vue?vue&type=script&lang=javascript&"
import style0 from "./Basics.vue?vue&type=style&index=0&id=1d25a2c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d25a2c6",
  null
  
)

export default component.exports